module.exports = __webpack_public_path__ + "static/media/web.697a44b5.svg";